const PreviewMessageArabicPushNotification = ({ arabicValues }) => {
  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="self-stretch px-5 flex flex-col justify-start items-start gap-2">
        <div className="self-stretch justify-start text-zinc-800 text-xs font-semibold font-['Montserrat']">
          Mobile Preview
        </div>
        <div className="self-stretch p-2.5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-300/90 inline-flex justify-end items-center gap-2">
          <div className="flex-1 inline-flex flex-col justify-start items-end gap-1.5">
            <div className="self-stretch inline-flex items-center gap-7">
              <div className="flex-1 inline-flex flex-col justify-start items-start gap-2">
                <div className="self-stretch text-right text-sky-900 text-xs font-semibold font-['Montserrat']">
                  {arabicValues.titleAr}
                </div>
                <div className="self-stretch text-right justify-center text-neutral-700 text-xs font-medium font-['Montserrat']">
                  {arabicValues.bodyAr}
                </div>
              </div>
            </div>
          </div>
          <img
            src="/images/kamco-logo.svg"
            alt="notification"
            className="w-10 h-10"
          />
        </div>
      </div>
      <div className="self-stretch px-5 flex flex-col justify-start items-start gap-2">
        <div className="self-stretch justify-start text-zinc-800 text-xs font-semibold font-['Montserrat']">
          {" "}
          Web Preview
        </div>
        <div className="self-stretch p-2.5 bg-[#ECECEC] rounded-xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] inline-flex justify-start items-start gap-2">
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-1.5">
            <div className="self-stretch inline-flex justify-end items-center gap-7">
              <div className="flex-1 inline-flex flex-col justify-start items-end gap-2">
                <div className="self-stretch inline-flex justify-start items-start gap-1.5">
                  <span className=" text-neutral-400">X</span>

                  <div className="flex-1 flex justify-end items-center gap-2">
                    <div className="justify-center text-sky-900 text-xs font-semibold font-['Montserrat']">
                      {arabicValues.titleAr}
                    </div>
                  </div>
                </div>
                <div className="justify-center text-neutral-700 text-xs font-medium font-['Montserrat']">
                  {arabicValues.bodyAr}
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-white rounded-xl p-1">
            <img
              src="/images/kamco-logo.svg"
              alt="notification"
              className="w-10 h-10"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewMessageArabicPushNotification;
